import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let lenis: Lenis | null = null;

export function initSmoothScroll(): Lenis {
  // Touch devices get shorter, snappier easing and skip wheel smoothing
  // (no wheel exists on touch). Lets native momentum feel right on iOS.
  const isTouch =
    typeof window !== "undefined" && window.matchMedia("(hover: none)").matches;

  lenis = new Lenis({
    duration: isTouch ? 0.7 : 1.1,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: !isTouch,
    wheelMultiplier: 1,
    touchMultiplier: isTouch ? 2 : 1.5,
  });

  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((time) => lenis!.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);

  return lenis;
}

export function getLenis(): Lenis | null {
  return lenis;
}

export function pauseScroll() {
  lenis?.stop();
  document.body.classList.add("lenis-stopped");
}

export function resumeScroll() {
  lenis?.start();
  document.body.classList.remove("lenis-stopped");
}

export function scrollToTop(immediate = true) {
  lenis?.scrollTo(0, { immediate });
}
